import { inject, Injectable } from '@angular/core';
import { LoggerService } from '@pf/shared-services';
import { TypeEntityTypes } from '@pf/shared-common';
import { ExceptionTypesService } from '@control-tower/platform-wms';
import {
    AbstractTypeEntityFacade,
    TypeEntityStore,
} from '@pf/shared/util-platform';

@Injectable()
export class ExceptionTypeFacade extends AbstractTypeEntityFacade<ExceptionTypesService> {
    constructor() {
        const typeService = inject(ExceptionTypesService);
        const store = inject(TypeEntityStore);
        const logger = inject(LoggerService);

        super(
            store,
            logger,
            typeService,
            'exceptionTypeGetAll',
            TypeEntityTypes.ExceptionType
        );
    }
}
